/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { useState } from 'react';
import brandThemes from '../../../../AppShell/brandtheme';

export default function CommonStates(product, brandId, plaSku = '') {
    const setImplementProductSubscription = (brandThemes[brandId]?.implement_product_subscription || false);
    const index = product?.productSkus?.findIndex((item) => item.id === plaSku);
    // States
    const [sortedData, setSortedData] = useState(product.productSkus);
    const [selectedSku, setSelectedSku] = useState(plaSku && index >= 0 ? product.productSkus[index] : product.productSkus[0]);
    const [quantity, setQuantity] = useState(1);
    const [hasWine, setHasWine] = useState(false);
    const [hasAddons, setHasAddons] = useState(product?.addonGroups?.length > 0);
    const [isAddToCartEnabled, setIsAddToCartEnabled] = useState(true);
    const [disableAddToCart, setDisableAddToCart] = useState(false);
    const [personalizedData, setPersonalizedData] = useState({});
    const [minicartModalOpen, setMinicartModalOpen] = useState(false);
    const [mobileAgeVerificationOpen, setMobileAgeVerificationOpen] = useState(false);
    const [baseProduct, setBaseProduct] = useState(null);
    const [addToCartData, setAddToCartData] = useState(null);
    const [subscription, setSubscription] = useState({
        subscriptionKey: ['CMC-SubscriptionDuration-v2', 'CMC-SubscriptionType-v2', 'CMC-SubscriptionInterval-v2'],
        subscriptionIndefinite: 'Continue until I stop',
        subscriptionType: ['basic', 'discovery'],
        implementProductSubscription: setImplementProductSubscription,
        viewSubscription: false,
        isTypeDiscovery: false,
        subscriptionCheckbox: false,
    });
    const [subscriptionDetails, setSubscriptionDetails] = useState({
        subscriptionType: '',
        subscriptionDuration: '',
        subscriptionFrequency: '',
        subscriptionDurationKey: '',
    });
    const [selectedState, setSelectedState] = useState('');
    const [alertType, setAltertType] = useState('');
    const [addToCartClicked, setAddToCartClicked] = useState(false);
    const [deliveryDate, setDeliveryDate] = useState('');
    const [variantVaseList, setVariantVaseList] = useState([]);
    const [activeVariant, setActiveVariant] = useState('');
    const [toastError, setToastError] = useState(false);
    return {
        sortedData,
        setSortedData,
        selectedSku,
        setSelectedSku,
        quantity,
        setQuantity,
        hasWine,
        setHasWine,
        hasAddons,
        setHasAddons,
        isAddToCartEnabled,
        setIsAddToCartEnabled,
        disableAddToCart,
        setDisableAddToCart,
        personalizedData,
        setPersonalizedData,
        minicartModalOpen,
        setMinicartModalOpen,
        mobileAgeVerificationOpen,
        setMobileAgeVerificationOpen,
        baseProduct,
        setBaseProduct,
        addToCartData,
        setAddToCartData,
        subscription,
        setSubscription,
        subscriptionDetails,
        setSubscriptionDetails,
        selectedState,
        setSelectedState,
        alertType,
        setAltertType,
        addToCartClicked,
        setAddToCartClicked,
        deliveryDate,
        setDeliveryDate,
        variantVaseList,
        setVariantVaseList,
        activeVariant,
        setActiveVariant,
        toastError,
        setToastError,
    };
}
